import { render, staticRenderFns } from "./SettingsNotificationMailingNameFrom.vue?vue&type=template&id=2cbe374b&"
import script from "./SettingsNotificationMailingNameFrom.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationMailingNameFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports